import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('purchase-list/index', {params});
    },
    show(id) {
        return Service().get('purchase-list/show/'+id);
    },
    create(params) {
        return Service().post('purchase-list/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('purchase-list/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('purchase-list/delete/'+id);
    },
    approval(id, params) {
        return Service().post('purchase-list/approval/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
}